const votingRubric = {
  categories: [
    {
      name: 'awesomeness',
      definition: 'How much thought was put behind this or how impressive was this to complete?',
      scoreHelpers: [
        'I’m unimpressed with the solution.',
        'Some thought was put behind this, but not completed well.',
        'It’s an okay project.',
        'Well THAT’s pretty cool!',
        'This is the best thing I have ever seen!',
      ],
    },
    {
      name: 'innovation',
      definition: 'How creative was this solution?',
      scoreHelpers: [
        'This is common sense',
        'I feel like most people have thought of this already',
        'Not a bad idea',
        'Well THAT’s pretty clever!',
        'Wow, this has never been considered before!',
      ],
    },
    {
      name: 'completeness',
      definition: 'How complete is the “product”? Besides engineering work, was there design work done, a final presentation or anything else that made this feel like a complete piece of work?',
      scoreHelpers: [
        'Little to no work was actually completed for this project.',
        'I feel like they could have done more. “MVP” Solution.',
        'They finished about as much as I’d expect',
        'Everything is complete, but still has a few small pieces to work out.',
        'Everything is complete and this is production ready.',
      ],
    },
    {
      name: 'utility',
      definition: 'Would I use this? How useful is this?',
      scoreHelpers: [
        'I’m not sure anyone would ever use this',
        'This is useful in some very specific circumstance',
        'Yeah, I can see how people might use it',
        'Well THAT’s pretty handy!',
        'This is extremely useful to the audience intended for this app. (Ie: Game to those who game, helper app to those in tech, etc)',
      ],
    },
    {
      name: 'difficulty',
      definition: 'How challenging was this work or project that the team took on?',
      scoreHelpers: [
        'This was not very challenging to complete or design this solution.',
        'This doesn’t seem THAT hard',
        'A decently challenging project',
        'They clearly had to do some impressive stuff to solve this',
        '🤯 Mind. Blown. 🤯',
      ],
    },
  ],
};

export default votingRubric;
